
export namespace ToroSaEnums {

    export enum TableDataType {
        Course,
        Area,
        Hole,
        Station
    }

    export enum SaZoneType {
        Area,
        Hole,
        Station
    }

    export enum BulkAdjustType {
        Replace,
        Shift
    }

    export enum SaMinThresholdOption {
        Disabled = 0,
        ToZero = 1,
        ToMinThresh = 2,
        ToMinThreshExcZeros = 3
    }
}
